import React, { useEffect } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import "./globalOverlay.scss";

export default function GlobalOverlay(props) {
  const { isVisible, portalId = "#react-global-overlay", ...rest } = props;

  useEffect(() => {
    const overlayDOM = document.querySelector(".react-global-overlay");
    if (overlayDOM) {
      overlayDOM.classList.add("fadeIn");
    }
  });

  if (!isVisible) return null;
  
  const overlay = <div className="react-global-overlay" {...rest} />;
  return ReactDOM.createPortal(overlay, document.querySelector(portalId));
}

GlobalOverlay.propTypes = {
  isVisible: PropTypes.bool
};
